module.exports = __webpack_public_path__ + "img/di_16_DebtCard.ea725e70.png";